export default __webpack_public_path__ + "static/media/banco-finandina.84dcf363.svg";